import { render, staticRenderFns } from "./PurchOrderUnReapBody.vue?vue&type=template&id=ebc82014&scoped=true&"
import script from "./PurchOrderUnReapBody.vue?vue&type=script&lang=js&"
export * from "./PurchOrderUnReapBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc82014",
  null
  
)

export default component.exports